import {
    GET_ALERTS,
    GET_ALERTS_SUCCESS,
    GET_ALERTS_FAILURE,
    GET_ALERT_DETAIL,
    GET_ALERT_DETAIL_SUCCESS,
    GET_ALERT_DETAIL_FAILURE,
    ADD_ALERT,
    ADD_ALERT_SUCCESS,
    ADD_ALERT_FAILURE,
    UPDATE_ALERT,
    UPDATE_ALERT_SUCCESS,
    UPDATE_ALERT_FAILURE,
    UPDATE_ALERT_STATUS,
    UPDATE_ALERT_STATUS_SUCCESS,
    UPDATE_ALERT_STATUS_FAILURE,
    ALERT_DETAIL_RESET,
} from '../constants';

const initialState = {
    AlertData: [],
    AlertDetailData: [],
    AddAlertData: [],
    loader: false,
    AddAlertLoader: false,
    DetailAlertLoader: false,
    alertsError: false,
};

export default function AlertManagementReducer(state = initialState, action) {
    switch (action.type) {
        case GET_ALERTS:
            state = {
                ...state,
                loader: true,
            };
            break;
        case GET_ALERTS_SUCCESS:
            state = {
                ...state,
                loader: false,
                AlertData: action.payload,
                alertsError: false,
            };
            break;
        case GET_ALERTS_FAILURE:
            state = {
                ...state,
                loader: false,
                AlertData: action.payload ? [] : state.AlertData,
                alertsError: !!action.payload,
            };
            break;
        case GET_ALERT_DETAIL:
            state = {
                ...state,
                DetailAlertLoader: true,
            };
            break;
        case GET_ALERT_DETAIL_SUCCESS:
            state = {
                ...state,
                DetailAlertLoader: false,
                AlertDetailData: action.payload,
            };
            break;
        case GET_ALERT_DETAIL_FAILURE:
            state = {
                ...state,
                DetailAlertLoader: false,
            };
            break;
        case ADD_ALERT:
            state = {
                ...state,
                AddAlertLoader: true,
            };
            break;
        case ADD_ALERT_SUCCESS:
            state = {
                ...state,
                AddAlertData: action.payload,
                AddAlertLoader: false,
            };
            break;
        case ADD_ALERT_FAILURE:
            state = {
                ...state,
                AddAlertLoader: false,
            };
            break;
        case UPDATE_ALERT:
            state = {
                ...state,
                AddAlertLoader: true,
            };
            break;
        case UPDATE_ALERT_SUCCESS:
            state = {
                ...state,
                AddAlertLoader: false,
            };
            break;
        case UPDATE_ALERT_FAILURE:
            state = {
                ...state,
                AddAlertLoader: false,
            };
            break;
        case UPDATE_ALERT_STATUS:
            state = {
                ...state,
                loader: true,
            };
            break;
        case UPDATE_ALERT_STATUS_SUCCESS:
            state = {
                ...state,
                loader: false,
            };
            break;
        case UPDATE_ALERT_STATUS_FAILURE:
            state = {
                ...state,
                loader: false,
            };
            break;
        case ALERT_DETAIL_RESET:
            state = {
                ...state,
                AlertDetailData: [],
            };
            break;
        default:
            state = { ...state };
    }
    return state;
}
